import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, CircularProgress, Box } from '@mui/material';

/**
 * OdmTypeFilter
 *
 * Props:
 *   value    — current selected value ('' means 'All')
 *   onChange — (newValue: string) => void
 *   options  — array of strings
 *   loading  — bool
 */
const OdmTypeFilter = ({ value = '', onChange, options = [], loading = false }) => {
  return (
    <FormControl size="small" sx={{ minWidth: 220 }}>
      <InputLabel id="odm-type-filter-label" shrink>ODM Type</InputLabel>
      <Select
        labelId="odm-type-filter-label"
        value={value}
        label="ODM Type"
        displayEmpty
        onChange={(e) => onChange && onChange(e.target.value)}
        disabled={loading}
        endAdornment={
          loading ? (
            <Box sx={{ display: 'flex', alignItems: 'center', pr: 2 }}>
              <CircularProgress size={16} />
            </Box>
          ) : null
        }
      >
        <MenuItem value="">
          <em>All</em>
        </MenuItem>
        {options.map((opt) => (
          <MenuItem key={opt} value={opt}>
            {opt}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default OdmTypeFilter;
